/**
 * Shared utilities for generating consistent R2 object keys
 */

/**
 * Sanitizes a filename by replacing unsafe characters with underscores
 */
export function sanitizeFilename(filename: string): string {
  return filename.replace(/[^a-zA-Z0-9._-]/g, '_')
}

/**
 * Generates the R2 key for a file (fileId-based storage)
 * Format: files/{fileId}/{sanitizedFilename}
 */
export function getFileKey(fileId: string, filename: string): string {
  const safeFilename = sanitizeFilename(filename)
  return `files/${fileId}/${safeFilename}`
}

/**
 * Generates the R2 key for a converted PDF (same location, .pdf extension)
 * Format: files/{fileId}/{sanitizedBasename}.pdf
 */
export function getPdfKey(fileId: string, originalFilename: string): string {
  const safeFilename = sanitizeFilename(originalFilename)
  const basename = safeFilename.replace(/\.[^.]+$/, '') // Remove extension
  return `files/${fileId}/${basename}.pdf`
}

/**
 * Generates the R2 key for a thumbnail
 * Format: files/{fileId}/thumb_{size}.png
 */
export function getThumbnailKey(fileId: string, size: 'small' | 'large'): string {
  return `files/${fileId}/thumb_${size}.png`
}

/**
 * Generates the R2 key for an extracted isometric view
 * Format: files/{fileId}/isometric.png
 */
export function getIsometricKey(fileId: string): string {
  return `files/${fileId}/isometric.png`
}
